import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Casino from '@dialinvest/react-casino';
import moment from 'moment';
import { adjustRecurrences } from './promotionHelper';

const PromotionWidgetWrapper = ({ id, limit, children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      const today = moment().format('YYYY-MM-DD');
      const validTo = moment(today, 'YYYY-MM-DD').add(30, 'days');
      const url = `pages/articles/?child_of=${id}&fields=body,excerpt,valid_from,valid_to,thumbnail,title,first_published_at&valid_from__gte=${moment().format('YYYY-MM-DD')}&valid_from__lte=${validTo.format('YYYY-MM-DD')}&limit=${limit}&show_in_calendar=true&recurrences=true&order=valid_from`;
      const result = await new Casino.FetchContent(url).perform();
      const values = adjustRecurrences(result.items()).slice(0, limit);

      setItems(values);
    };

    fetchArticles();
  }, [id, limit]);

  return children({
    items,
  });
};

PromotionWidgetWrapper.propTypes = {
  children: PropTypes.func,
  id: PropTypes.number.isRequired,
  limit: PropTypes.node,
};

PromotionWidgetWrapper.defaultProps = {
  children: null,
  limit: 4,
};

export default PromotionWidgetWrapper;
